
define('text!templates/modules/profile/edit/account-info-edit-form.html',[],function () { return '<div class="firstname-input"></div>\n<div class="lastname-input"></div>\n<div class="email-input"></div>\n\n<div class="password-input"></div>\n';});

